<template>
  <div class="pt-2">
    <v-card flat>
      <v-form v-model="valid">
        <v-row no-gutters align="center" justify="space-around">
          <v-col cols="12" sm="1" style="text-align: right">
            <label>科目编号:</label>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
              class="form-item-value"
              v-model="filter.subjectCode"
              label=""
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>科目名称：</label>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
              class="form-item-value"
              v-model="filter.subjectName"
              label=""
              outlined
              dense
            ></v-text-field>
          </v-col>
            <v-col cols="12" sm="1" style="text-align: right">
                <label>门店：</label>
            </v-col>
            <v-col cols="12" sm="2">
                <pd-shop-multiple-list
                        v-model="filter.shopIdList"
                        isSearch
                ></pd-shop-multiple-list>
            </v-col>
          <v-col cols="12" sm="1"></v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" class="mr-2" depressed @click="handleSearch"
              >查询</v-btn
            >
            <v-btn :disabled="_hasButtonPermission('编辑')" depressed @click="handleResetSearch">重置</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
              :headers="headers"
              fixed-header
              :items="desserts"
              class="elevation-1 mt-2"
              :loading="loading"
              :server-items-length="totalDesserts"
              :page.sync="filter.pageNum"
              :items-per-page.sync="filter.pageSize"
              @update:page="handlePageChanged"
              @update:items-per-page="handlePageSizeChanged"
      >
        <template
                v-slot:body="{ items }"
        >
          <tbody>
          <tr
                  v-for="(item,index) in items"
                  :key="item.id"
          >
            <td class="border-right-a">{{ item.shopId }}</td>
            <td class="border-right-a">{{ item.shopName }}</td>
            <td class="border-right-a">{{ item.subjectCode}}</td>
            <td class="border-right-a">{{ item.subjectName }}</td>
            <td>
              <v-btn v-if="item.status == 0 " :disabled="_hasButtonPermission('编辑')" icon class="mr-2" text @click="editStaffing(item)">
                指定人员
              </v-btn>
                <v-btn v-if="item.status == 1 "  :disabled="_hasButtonPermission('编辑')" icon class="mr-2" text @click="editStaffing(item)">
                    修改人员
                </v-btn>
            </td>
          </tr>
          </tbody>
        </template>
      </v-data-table>

      <el-dialog
              :key="aaa"
              title="科目人員配置"
              :visible.sync="dialogVisible"
              width="100%"
              :before-close="handleClose">
        <template>
          <div>
            <el-row>
              <el-col :span="12">
                <p style="text-align: center; margin: 0 0 20px">分管负责人</p>
                <div style="text-align: center">
                  <el-transfer
                          style="text-align: left; display: inline-block"
                          v-model="value1"
                          filterable
                          :render-content="renderFunc"
                          :titles="['源列表', '目标列表']"
                          :button-texts="['移除', '添加']"
                          :format="{
        noChecked: '${total}',
        hasChecked: '${checked}/${total}'
      }"
                          :data="data1">
                  </el-transfer>
                </div>
              </el-col>
              <el-col :span="12">
                <p style="text-align: center; margin: 0 0 20px">工程经理</p>
                <div style="text-align: center">
                  <el-transfer
                          style="text-align: left; display: inline-block"
                          v-model="value2"
                          filterable
                          :render-content="renderFunc"
                          :titles="['源列表', '目标列表']"
                          :button-texts="['移除', '添加']"
                          :format="{
        noChecked: '${total}',
        hasChecked: '${checked}/${total}'
      }"
                          :data="data2">
                  </el-transfer>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <p style="text-align: center; margin: 0 0 20px">工程主管</p>
                <div style="text-align: center">
                  <el-transfer
                          style="text-align: left; display: inline-block"
                          v-model="value3"
                          filterable
                          :render-content="renderFunc"
                          :titles="['源列表', '目标列表']"
                          :button-texts="['移除', '添加']"
                          :format="{
        noChecked: '${total}',
        hasChecked: '${checked}/${total}'
      }"
                          :data="data3">
                  </el-transfer>
                </div>
              </el-col>
              <el-col :span="12">
                <p style="text-align: center; margin: 0 0 20px">工程人员</p>
                <div style="text-align: center">
                  <el-transfer
                          style="text-align: left; display: inline-block"
                          v-model="value4"
                          filterable
                          :render-content="renderFunc"
                          :titles="['源列表', '目标列表']"
                          :button-texts="['移除', '添加']"
                          :format="{
        noChecked: '${total}',
        hasChecked: '${checked}/${total}'
      }"
                          :data="data4">
                  </el-transfer>
                </div>
              </el-col>
            </el-row>
          </div>
        </template>

        <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="saveItem">确 定</el-button>
  </span>
      </el-dialog>






    </v-card>
  </div>
</template>

<script>
import { default as StaffingApi } from "../../../../api/pd/maintenance/staffing/StaffingApi.js";
export default {
  name: 'Pd-Manager-Staffing',
  props: {
    buttonPriviledgeList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      aaa: 1,
      dialogVisible: false,
      value1: [],
      value2: [],
      value3: [],
      value4: [],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      renderFunc(h, option) {
        return <span>{ option.label }</span>;
      },
      tab: null,
      filter: {
        shopIdList: [],
        subjectCode: "",
        subjectName: "",
        pageNum: 1,
        pageSize: 15,
      },
      headers: [
        {
          text: "门店编号",
          value: "shopId",
          sortable: false,
          width: 65,
          divider: true
        },
        {
          text: "门店名称",
          value: "shopName",
          sortable: false,
          width: 100,
          divider: true
        },
        {
          text: "科目编号",
          align: "start",
          sortable: false,
          value: "subjectCode",
          width: 120,
          divider: true
        },
        {
          text: "科目名称",
          align: "start",
          sortable: false,
          value: "subjectName",
          width: 80,
          divider: true
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "status",
          width: 150,
          divider: true
        },
      ],
      desserts: [],
      loading: false,
      totalDesserts: 0,
      valid: false,
      auditDialog: false,
      checkId: null,
      btnDisabled: false,
      edit:{
        item: {},
        dialog:false,
        subjectList:[],
      }
    };
  },
  created() {
  },
  mounted() {
      this.getButtonPriviledge();
      this.getDataFromApi();
  },
  methods: {
    viewDetail(item) {
      this.$emit("viewDetailCallback", {
        formStatus: "detail",
        checkId: item.id,
      });
    },
    handleSearch() {
      this.filter.pageNum = 1;
      this.getDataFromApi();
    },
    handleResetSearch() {
      this.filter = {
        id: "",
        name: "",
        pageNum: 1,
        pageSize: 15,
      };
      this.getDataFromApi();
    },
    handlePageChanged(pageNum) {
      this.filter.pageNum = pageNum;
      this.getDataFromApi();
    },
    handlePageSizeChanged(pageSize) {
      if (pageSize == -1) {
        pageSize = 100;
      }
      this.filter.pageNum = 1;
      this.filter.pageSize = pageSize;
      this.getDataFromApi();
    },
    getQueryParams(query) {
      return query;
    },
    async getDataFromApi() {
      let me = this;
      me.loading = true;
      let queryUserResp = await StaffingApi.list(me.filter);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取科目人员管理失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      me.loading = false;
      me.desserts = data.data.rows;
      me.totalDesserts = data.data.total;
    },


    groupToggle(group){
      this.$set(this.$refs.data.openCache, group, !this.$refs.data.openCache[group])
    },
    getHeadTextByValue(value){
      let head = this.headers.filter(head=>{return head.value == value});
      return head[0].text;
    },
    // handleChangeA(value, direction, movedKeys) {
    //   console.log(value);
    //   let me = this;
    //   let dataMap = new Map();
    //   this.result1 = new Array();
    //   for(let i = 0;i< me.data1.length;i++){
    //     dataMap.set(me.data1[i].key,me.data1[i]);
    //   }
    //   for(let i = 0;i< value.length;i++ ) {
    //     this.result1.push(dataMap.get(value[i]));
    //   }
    //     console.log(this.result1);
    // },
    // handleChangeB(value, direction, movedKeys) {
    //   let me = this;
    //   let dataMap = new Map();
    //   this.result2 = new Array();
    //   for(let i = 0;i< me.data2.length;i++){
    //     dataMap.set(me.data2[i].key,me.data2[i]);
    //   }
    //   for(let i = 0;i< value.length;i++ ) {
    //     this.result2.push(dataMap.get(value[i]));
    //   }
    // },
    // handleChangeC(value, direction, movedKeys) {
    //   let me = this;
    //   let dataMap = new Map();
    //   this.result3 = new Array();
    //   for(let i = 0;i< me.data3.length;i++){
    //     dataMap.set(me.data3[i].key,me.data3[i]);
    //   }
    //   for(let i = 0;i< value.length;i++ ) {
    //     this.result3.push(dataMap.get(value[i]));
    //   }
    // },
    // handleChangeD(value, direction, movedKeys) {
    //   let me = this;
    //   let dataMap = new Map();
    //   this.result4 = new Array();
    //   for(let i = 0;i< me.data4.length;i++){
    //     dataMap.set(me.data4[i].key,me.data4[i]);
    //   }
    //   for(let i = 0;i< value.length;i++ ) {
    //     this.result4.push(dataMap.get(value[i]));
    //   }
    // },
    generateData(roleId, index,shopId,subjectCode) {
      let me = this;
      let param = {};
      param.roleId = roleId;
      param.shopId = shopId;
      param.subjectCode = subjectCode;
      let data = new Array();
      StaffingApi.getStaffing(param).then(resp =>{
        if (!resp.data || !resp.data.code || resp.data.code != 200) {
          let msg = resp.msg;
          msg = !msg || msg == "" ? "获取科目人员配置失败" : msg;
        }else{
          data = resp.data.data;
          let dataAll = data.all;
          let dataCopy = new Array();
          for(let j = 0;j<dataAll.length; j++){
            dataCopy.push({
              key: dataAll[j].userId,
              label: dataAll[j].userName
            });
          }

          if(index == 0){
            me.data1 = dataCopy;
            console.log(me.data1);
          }
          if(index == 1){
            me.data2 = dataCopy;
          }
          if(index == 2){
            me.data3 = dataCopy;
          } if(index == 3){
            me.data4 = dataCopy;
          }

          let dataValue = data.value;
          dataCopy = dataValue;
          if(index == 0){
              me.value1 = dataCopy;
          }
          if(index == 1){
            this.value2 = dataCopy;
          }
          if(index == 2){
            this.value3 = dataCopy;
          } if(index == 3){
            this.value4 = dataCopy;
          }
        }
      });
    },
    saveItem(){
      let me = this;
      let shopId = this.edit.item.shopId;
      let subjectCode = this.edit.item.subjectCode;
      let dataMap1 = new Map();
      let dataMap2 = new Map();
      let dataMap3 = new Map();
      let dataMap4 = new Map();
      for(let i = 0;i< me.data1.length;i++){
          dataMap1.set(me.data1[i].key,me.data1[i].label);
      }
      for(let i = 0;i< me.data2.length;i++){
        dataMap2.set(me.data2[i].key,me.data2[i].label);
      }
      for(let i = 0;i< me.data3.length;i++){
        dataMap3.set(me.data3[i].key,me.data3[i].label);
      }
      for(let i = 0;i< me.data4.length;i++){
        dataMap4.set(me.data4[i].key,me.data4[i].label);
      }
      let dataCopy = new Array();

      for(let i = 0;i<me.value1.length; i++){
        dataCopy.push({
          roleId:1,
          userId: me.value1[i],
          userName: dataMap1.get(me.value1[i]),
          shopId:shopId,
          subjectCode:subjectCode
        });
      }
        for(let i = 0;i<me.value2.length; i++){
            dataCopy.push({
                roleId:2,
                userId: me.value2[i],
                userName: dataMap2.get(me.value2[i]),
                shopId:shopId,
                subjectCode:subjectCode
            });
        }
        for(let i = 0;i<me.value3.length; i++){
            dataCopy.push({
                roleId:3,
                userId: me.value3[i],
                userName: dataMap3.get(me.value3[i]),
                shopId:shopId,
                subjectCode:subjectCode
            });
        }

        for(let i = 0;i<me.value4.length; i++){
            dataCopy.push({
                roleId:4,
                userId: me.value4[i],
                userName: dataMap4.get(me.value4[i]),
                shopId:shopId,
                subjectCode:subjectCode
            });
        }

      StaffingApi.addStaffing(dataCopy).then(resp =>{
        if (!resp.data || !resp.data.code || resp.data.code != 200) {
          let msg = resp.msg;
          msg = !msg || msg == "" ? "添加科目人员配置失败" : msg;
          this.$dialog.error({
            text: resp.data.msg +':'+ resp.data.msg_detail,
            title: "操作失败",
          });
          return false;
        }else{
          this.$dialog.info({
            text: resp.data.msg,
            title: "操作成功",
          });
        }
        this.dialogVisible = false;
        this.getDataFromApi();
      })
    },

    onInit: function () {
      return Promise.resolve()
    },
    editStaffing(item){
      this.edit.item = Object.assign({}, item);
      let that = this
      this.onInit().then(function () {
        return that.generateData(1,0,that.edit.item.shopId,that.edit.item.subjectCode);
      }).then(function () {
        return that.generateData(2,1,that.edit.item.shopId,that.edit.item.subjectCode);
      }).then(function () {
        return that.generateData(3,2,that.edit.item.shopId,that.edit.item.subjectCode);
      }).then(function () {
        return that.generateData(4,3,that.edit.item.shopId,that.edit.item.subjectCode);
      }).then(function () {
        that.dialogVisible = true
      })
    },


    handleClose() {
      this.dialogVisible = false;
    },
      getButtonPriviledge(){
          console.log('this.page',this.page)
          let menuId = this.page.id
          let me = this
          PermissionApi.queryButtonPriviledge(menuId,null).then(resp=>{
              PermissionApi.handleResponse(resp, me, function (data){
                  me.buttonPriviledgeList = data.buttonPriviledges
                  console.log('buttonPriviledgeList',me.buttonPriviledgeList)
              })
          })
      },
      _hasButtonPermission(name){
          let buttonPriviledgeList = this.buttonPriviledgeList
          let hasButton =false
          for(let i=0;i<buttonPriviledgeList.length;i++){
              if(buttonPriviledgeList[i].name==name){
                  if(buttonPriviledgeList[i].hasPriviledge=='Y'){
                      return true
                  } else {
                      return false
                  }
              }
          }
          return false
      },
  },
};
</script>
<style scoped>
.padding-bottom {
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}
.padding-top {
  padding-top: 30px;
}
.margin-right {
  margin-right: 12px;
}
</style>